<mat-expansion-panel [expanded]="true" class="files-card">
  <mat-expansion-panel-header collapsedHeight="100px" expandedHeight="100px">
    <mat-panel-title>
       <h2>{{'docDocuments.title'|transloco}}</h2>
    </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-dialog-content>
      <form [formGroup]="areaFormGroup">
        <mat-expansion-panel *ngFor="let section of possibleSections" [expanded]="true" class="files-card">
          <mat-expansion-panel-header collapsedHeight="100px" expandedHeight="100px">
            <mat-panel-title>
              <h2>{{ section.name}}</h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>{{getSubtitle(section.id)}}</p>
          <div class="tablecontainer">
            <div class="sectionContainer" *ngFor="let document of getSection(section.id).documents">
              <table mat-table [dataSource]="data.get(section.id)?.get(document.index) ?? []" class="mat-elevation-z8">
                <ng-container *ngFor="let columnName of columnNames; let iCol = index" [matColumnDef]="columnName">
                  <th mat-header-cell [style.display]="getDisplayClass(section.id,columnName)" *matHeaderCellDef>{{ ('docDocuments.'+columnName)|transloco }}</th>
                  @if (columnName==='name') {
                  <td  [attr.rowspan]="iRow === 0? document.linkedEvidences.length : 0" mat-cell *matCellDef="let row; let iRow = index"
                  [style.display]="iRow === 0 ? ''  : 'none'">{{ document.name.trim() }}</td>
                  }@else if (columnName==='evidences') {
                  <td [style.display]="getDisplayClass(section.id,columnName)" mat-cell *matCellDef="let row; let iRow = index">{{ possibleEvidences.get(row.evidenceType)?.name }}</td>
                  }@else if (columnName==='validityPeriod') {
                  <td [style.display]="getDisplayClass(section.id,columnName)" mat-cell *matCellDef="let row; let iRow = index">{{getDateRangeLable(row.validFrom, row.validTo)}}</td>
                  }@else if (columnName === 'actions') {
                    <td [attr.rowspan]="iRow === 0? document.linkedEvidences.length : 0" mat-cell *matCellDef="let row; let iRow = index"
                    [style.display]="iRow === 0 ? ''  : 'none'">
                      <button *ngIf="this.isEditable" mat-icon-button color="primary" (click)="deleteEvidence(section.id,document.index)">
                        <mat-icon>delete</mat-icon>
                      </button>
                      <button mat-icon-button color="primary" (click)="onViewDocumentClick(section.id,document)">
                        <mat-icon>preview</mat-icon>
                      </button>
                    </td>
                  } @else {
                    <td [style.display]="skipAdditionalInformations(section.id,columnName)? 'none' : ''" mat-cell *matCellDef="let row; let iRow = index">{{ row[columnName] }}</td>
                  }
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
                <tr mat-row *matRowDef="let row; columns: columnNames"></tr>
              </table>
              <mat-form-field *ngIf="document.comment && document.comment.trim().length > 0" class="full-width comment-form-field commentBox" appearance="outline">
                <mat-label class="label-large">
                  {{ 'docDocuments.comments' | transloco }}
                </mat-label>
                <textarea class="no-resize-textarea" matInput [formControlName]="documentPrefix+section.id+document.index" maxlength="250" rows="3">
                </textarea>
              </mat-form-field>
            </div>
          </div>
          <button *ngIf="this.isEditable" mat-raised-button (click)="opendialog(section)" color="primary" class="custom-button-top"
            type="button">
            <mat-icon class="material-icons left">add</mat-icon>
            {{ getDownloadtitle(section.id) }}
          </button>
          <div *ngIf="section.possibleCheckboxFields.length > 0" class="checkboxArea">
            <p>{{ 'docDocuments.checkboxTitle' | transloco }}</p>
            <mat-checkbox (click)="updateCheckbox(section.id,checkboxid)" *ngFor="let checkboxid of section.possibleCheckboxFields" [formControlName]="checkboxPrefix+section.id+'_'+checkboxid">
              {{possibleCheckboxes.get(checkboxid)?.name}}
            </mat-checkbox>
          </div>
        </mat-expansion-panel>
      </form>
    </mat-dialog-content>
  </mat-expansion-panel>

